import { CalendarClockIcon } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { cn } from "utils/cn";
import { ROUTES } from "utils/constants";

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "components/AlertDialog";

export default function ExpiredSubscriptionDialog({
  isOpen,
  setIsOpen,
}: {
  isOpen: boolean;
  setIsOpen: (open: boolean) => void;
}) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <AlertDialog open={isOpen} onOpenChange={setIsOpen}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <div
            className={cn(
              "w-20 h-20 m-auto mb-5  rounded-full flex items-center justify-center bg-general-orange-700 border border-general-orange-800",
            )}
          >
            <CalendarClockIcon className="w-10 h-10 stroke-general-orange-900" />
          </div>
          <AlertDialogTitle className="text-center">{t("settings.expiredSubscriptionDialog.title")}</AlertDialogTitle>
          <AlertDialogDescription className="text-center">
            {t("settings.expiredSubscriptionDialog.description")}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel className="w-full md:flex-1">{t("button.later")}</AlertDialogCancel>
          <AlertDialogAction className="w-full md:flex-1" onClick={() => navigate(ROUTES.CHECKOUT)}>
            {t("button.choosePackage")}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
